import ReporteStockDelete from './ReporteStockDelete'
export {ReporteStockDelete}
export default ReporteStockDelete
